import {mean} from '@/utils/linalg'

// Execute a smooth mean filter with a kernel size of `3 x 3` in the array.
// For array values outside the boundaries the mean value of the entire
// `xs` array is used as default
export function meanFilter(xs, width) {
  const xsMean = mean(xs)
  return Array(xs.length)
          .fill(0)
          .map((_, i) => {
            const kernel = getKernel(i, width, xs.length, 3)
            const total = kernel.reduce((acc, i) => i < 0 ? acc + xsMean : acc + xs[i], 0)
            return total / kernel.length
          })
}

// Return a kernel of size `kernelSize` x `kernelSize` placed on top of `centerIdx` in a
// 2d array of width `width` and size `size`. Out-of-boundary indexes are represented
// with value -1.
export const getKernel = (centerIdx, width, size, kernelSize = 3) => {
  if (kernelSize % 2 === 0) { throw new Error('`kernelSize` must be an odd number') }

  const getRow = i => Math.floor(i / width)
  const getIndex = (ref, offset) => {
    const i = ref + offset
    return ref >= 0 && getRow(i) === getRow(ref) && i < size
      ? i
      : -1
  }

  let kernel = []
  const middle = Math.floor(kernelSize / 2)
  for (var i = -middle; i <= middle; i++) {
    const row = centerIdx + (i*width)
    for (var j = -middle; j <= middle; j++) {
      kernel.push(getIndex(row, j))
    }
  }

  return kernel
}
